
import {
    GET_RENTAL_CONTRACTS,

} from "./actions";

const initialState = {
  rentalContractList: {
    docs: [],
    totalAgreementCreated:0,
    totalAgreementSent:0,
    totalESignCompleted:0,
    totalOwnerSign:0,
    totalPropertyAccepted:0,
    totalTenantSign:0,
    totalDocs: 0,
    
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
 
  loading: true,
};

const rentalContractReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_RENTAL_CONTRACTS:
      return {
        ...state,
        rentalContractList: payload,
        loading: false,
      };
   
    default:
      return state;
  }
};
export default rentalContractReducer;
